import PublicH1 from 'developer-docs-shared-components/components/PublicH1';
import MdxHeader from './MdxHeader';
import { H1 } from 'UIComponents/elements/headings';
import { useDevDocsTheme } from 'developer-docs-shared-components/config/themes';
import { jsx as _jsx } from "react/jsx-runtime";
function MdxH1(props) {
  const {
    isPublicTheme
  } = useDevDocsTheme();
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: isPublicTheme ? PublicH1 : H1
  }, props));
}
export default MdxH1;